import { omniAtom } from "src/utils/atoms";

export const violationReportModalMerchflowIdAtom = omniAtom({
  prefix: "modals/violationReport",
  key: "merchflowId",
  value: null as null | number,
});
